<template>
  <svg
    :width="width ? width : '17'"
    :height="height ? height : '16'"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.16666 6L8.49999 11.3333L13.8333 6"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  name: "ArrowDownIcon",
   props: { width: Number, height: Number },
};
</script>
